<script>
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store";
import GoodToGoDialog from "@/views/trips/components/dialogs/GoodToGoDialog.vue";

export default {
  name: "GoodToGoAction",
  components: { GoodToGoDialog },
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
    truck: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["finish"],
  data() {
    return {
      showDialog: false,
      loading: false,
      goodToGoData: {},
    };
  },
  watch: {
    async showDialog(value) {
      if (value) {
        this.goodToGoData.timezone = this.stop.facility.timezone;
        const date = this.$dayjs().tz(this.goodToGoData.timezone);
        this.goodToGoData.date = date.format("YYYY-MM-DD");
        this.goodToGoData.time = date.format("HH:mm");
      }
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showCheckOutConfirmation() {
      this.showDialog = true;
    },
  },
};
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="flat"
    @click="showCheckOutConfirmation"
  >
    Good to go
  </v-btn>

  <good-to-go-dialog v-model="showDialog" :route="route" :stop="stop" :trip-id="trip.id" @finish="$emit('finish')" />
</template>

<style lang="scss" scoped></style>
